function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "1.174,103.924 13.01,90.547 14.55,80.3 27.173,66.923 29.524,60.616 53.942,40.94 61.02,21.281  64.984,19.668 70.48,7.88 111.409,19.668 135.819,0 144.485,9.437 159.475,55.111 176.775,56.692 179.905,59.06 186.196,59.06  198.826,40.94 198.826,70.855 191.733,74.771 194.895,80.3 183.854,90.547 182.265,103.924 191.733,107.88 197.238,117.309  197.238,127.556 183.854,125.196 179.905,170.848 172.828,176.368 168.912,174.771 150.793,156.717 137.376,172.42 126.351,174.771  124.007,184.256 118.519,188.172 112.998,186.607 94.883,200 92.507,190.531 74.413,166.955 70.48,155.111 62.577,148.828  53.942,162.991 31.137,166.955 18.539,123.607 5.122,121.24 "
});

var Svg17 = function Svg17(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MOR",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg17, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/17.8a73133d.svg";
export { ForwardRef as ReactComponent };